import { TOUR_STORAGE_PREFIX } from "./constants";
import type { TourDismissal } from "./types";

import { useAuth } from "@/lib/hooks/useAuth";
import { useLocalStorage } from "@/lib/hooks/useLocalStorage";

export function useTourDismissal(tourId: string, dismissal: TourDismissal) {
  const { userId } = useAuth();
  const [isStoredDismissed, setStoredDismissed] = useLocalStorage<boolean>(
    `${TOUR_STORAGE_PREFIX}${tourId}:${dismissal}:${userId ?? ""}`,
    false,
  );

  const dismiss = () => {
    if (!userId) return;
    setStoredDismissed(true);
  };

  return [Boolean(userId) && isStoredDismissed, dismiss] as const;
}
